import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { TelemetryService } from './telemetry.service';

/**
 * Global error handler that forwards uncaught Angular errors to App Insights
 * before falling back to the default console behaviour.
 *
 * TelemetryService is pulled lazily via the Injector to avoid a DI cycle:
 * ErrorHandler is constructed very early, before the full provider graph is
 * ready, so we resolve the service on first error instead of in the ctor.
 */
@Injectable()
export class TelemetryErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: unknown): void {
    try {
      this.injector.get(TelemetryService).trackException(error, {
        handledAt: 'GlobalErrorHandler',
      });
    } catch {
      // Telemetry must never mask the original error.
    }
    // Preserve default behaviour so errors stay visible in the console.
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
